import * as api from "./middleware/api.middleware";
import { getAuthHeader } from "./auth/authHeaders";
import {
  CreateSupportRequestPayload,
  CreateSupportRequestResponse,
  SupportRequestListItem,
  SupportRequestListResponse,
} from "../interfaces";

// Relative, so the middleware prefixes REACT_APP_API_URL like every other service.
// A hardcoded URL here sent support calls to localhost while the rest of the portal
// talked to the configured API, and the token from that API was rejected.
const serviceUrl = "support-requests";
const getAccessToken = () => getAuthHeader();

export function createSupportRequest(data: CreateSupportRequestPayload) {
  return api.post<CreateSupportRequestResponse>(
    serviceUrl,
    data,
    getAccessToken()
  );
}

export function getSupportRequests(customerId: number, environmentId: number) {
  const query = new URLSearchParams({
    customer_id: String(customerId),
    environment_id: String(environmentId),
  }).toString();
  return api.get<SupportRequestListResponse>(
    `${serviceUrl}?${query}`,
    getAccessToken()
  );
}

// Binary types come back as a Blob, text ones (logs, txt) as a string.
export function downloadSupportAttachment(
  requestId: number,
  attachmentId: number
) {
  return api.get<Blob | string>(
    `${serviceUrl}/${requestId}/attachments/${attachmentId}`,
    getAccessToken()
  );
}

// Marks the ticket resolved; the backend emails the reporter with support in copy.
export function closeSupportRequest(requestId: number) {
  return api.post<SupportRequestListItem>(
    `${serviceUrl}/${requestId}/close`,
    {},
    getAccessToken()
  );
}
